import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalRightService } from '../../../../../services/modal-right/modal-right.service';
import { ParametreDocumentStateService } from '../../../../../services/parametre-document/parametre-document-state.service';
import { PARAMETRE_TYPE_DOCUMENT_ACHAT } from '../../../../../services/parametre-document/parametre-document-type-ids';
import { saveParametreDocTypeRow } from '../../../../../services/parametre-document/parametre-document-child-save.util';

@Component({
    selector: 'app-doc-achat-facture-fornisseur',
    templateUrl: './doc-achat-facture-fornisseur.component.html',
    styleUrls: ['./doc-achat-facture-fornisseur.component.scss']
})
export class DocAchatFactureFornisseurComponent implements OnInit {
    saving = false;
    private readonly typeId = PARAMETRE_TYPE_DOCUMENT_ACHAT.factureFournisseur;

    constructor(
        private customizerService: ModalRightService,
        private state: ParametreDocumentStateService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.state.ensureLoaded().subscribe();
    }

    saveParametreDocument(): void {
        saveParametreDocTypeRow(this.state, this.toastr, this.typeId, 'achat', {}, (v) => (this.saving = v));
    }

    appercue(): void {
        this.customizerService.open();
    }
}
